import {useEffect, useState} from "react";
import {onAuthStateChanged} from "@firebase/auth";
import {auth} from "@/services/firebase.service";


// This hook only works after the first render on the client. Not currently for SSR.
export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        user.getIdTokenResult(true)
          .then((idTokenResult) => {
            setIsAdmin(!!idTokenResult.claims.gamesAdmin)
          })
      }
      else {
        setIsAdmin(false)
      }
    })
  }, [])

  return isAdmin
}